import {
  makeStyles,
} from '@material-ui/core'
import React from 'react'
import AdminDrawer from './AdminDrawer'
import ManageSurveys from './ManageSurveys'
import ManageUsers from './ManageUsers'
import ManageComments from './ManageComments'
import FooterBar from '../../components/FooterBar'
import { useHistory } from 'react-router-dom'
import decodeJWT from 'jwt-decode'

const useStyles = makeStyles(_theme => ({
  grow: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '90%',
  }
}))

const MENU_MAPPER = {
  users: ManageUsers,
  surveys: ManageSurveys,
  comments: ManageComments,
}

function AdminPage(props) {
  const classes = useStyles()
  const Component = MENU_MAPPER[props.menu]
  const history = useHistory()
  let sessionRemainingTime
  let userProfile, userName

  const token = localStorage.getItem('token')

  if (!token) {
    history.replace('/login')
  }

  if (token) {
    const now = new Date()
    const decodedToken = decodeJWT(token)
    userProfile = decodedToken.profile
    userName = decodedToken.name
    const tokenExpirationDate = new Date(decodedToken.exp * 1000)
    const isExpired = now >= tokenExpirationDate
    sessionRemainingTime = new Date(tokenExpirationDate - now).getTime() / 1000

    if (isExpired) {
      localStorage.clear('token')
      history.replace('/login')
    }
  }

  return (
    <div style={{ height: '100%' }}>
      <AdminDrawer
        userProfile={ userProfile }
        userName={ userName }
        remainingTime={ sessionRemainingTime }
      />
      <div className={ classes.grow }>
        <Component userProfile={ userProfile } />
      </div>
      <FooterBar />
    </div>
  )
}

export default AdminPage
